import React, { Component } from 'react';
/* Custom Amplify components */
import CustomSignIn from './components/amplify/CustomSignIn';
import CustomConfirmSignIn from './components/amplify/CustomConfirmSignIn';
import CustomVerifyContact from './components/amplify/CustomVerifyContact';
import CustomSignUp from './components/amplify/CustomSignUp';
import CustomConfirmSignUp from './components/amplify/CustomConfirmSignUp';
import CustomForgotPassword from './components/amplify/CustomForgotPassword';

/* Shared components */
import Navigation from './components/Navigation';
import BottomFooter from './components/BottomFooter';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import theme from './themes/QRSticker';
import Amplify from 'aws-amplify';
import { withAuthenticator } from 'aws-amplify-react';
import environment from './environments';

Amplify.configure({
  Auth: {        
      region: environment.COGNITO_REGION,
      userPoolId: environment.COGNITO_USER_POOL,
      userPoolWebClientId: environment.COGNITO_CLIENT_ID,
  }
});

class App extends Component {
  render() {
    return (
      <div className='app'>
        <MuiThemeProvider theme={theme}>
          <Navigation screenProps={{...this.props}}/>
          <BottomFooter />
        </MuiThemeProvider>
      </div>
    );
  }
}

export default withAuthenticator(App, false, [
  <CustomSignIn/>,
  <CustomConfirmSignIn/>,
  <CustomVerifyContact/>,
  <CustomSignUp/>,
  <CustomConfirmSignUp/>,
  <CustomForgotPassword/>,
]);